import apiClient from './client';

// ==================== AUTH ====================
export const authAPI = {
  login: (credentials) => apiClient.post('/jwt-auth/v1/token', credentials),
  register: (data) => apiClient.post('/wp/v2/users/register', data),
  getProfile: () => apiClient.get('/xpunters/v1/user/profile'),
  updateProfile: (data) => apiClient.post('/xpunters/v1/user/profile', data),
  getUserRole: () => apiClient.get('/xpunters/v1/user/role'),
};

// ==================== BET CODES ====================
export const betCodeAPI = {
  getList: (params) => apiClient.get('/xpunters/v1/bet-codes', { params }),
  getSingle: (id) => apiClient.get(`/xpunters/v1/bet-codes/${id}`),
  create: (data) => apiClient.post('/xpunters/v1/bet-codes', data),
  like: (id) => apiClient.post(`/xpunters/v1/bet-codes/${id}/like`),
  comment: (id, data) => apiClient.post(`/xpunters/v1/bet-codes/${id}/comment`, data),
  reply: (id, data) => apiClient.post(`/xpunters/v1/bet-codes/${id}/reply`, data),
  getComments: (id, params) => apiClient.get(`/xpunters/v1/bet-codes/${id}/comments`, { params }),
  mark: (id, data) => apiClient.post(`/xpunters/v1/bet-codes/${id}/mark`, data),
  getMark: (id) => apiClient.get(`/xpunters/v1/bet-codes/${id}/user-mark`),
  uploadProof: (id, data) => apiClient.post(`/xpunters/v1/bet-codes/${id}/upload-proof`, data),
  updateStatus: (id, data) => apiClient.post(`/xpunters/v1/bet-codes/${id}/status`, data),
  getPrivateList: (params) => apiClient.get('/xpunters/v1/bet-codes/private/list', { params }),
  getPublic: (id) => apiClient.get(`/xpunters/v1/public/bet-code/${id}`),
  getPublicComments: (id) => apiClient.get(`/xpunters/v1/public/bet-code/${id}/comments`),
};

// ==================== COMPETITIONS ====================
export const competitionAPI = {
  getList: (params) => apiClient.get('/xpunters/v1/competitions', { params }),
  getSingle: (id) => apiClient.get(`/xpunters/v1/competitions/${id}`),
  create: (data) => apiClient.post('/xpunters/v1/competitions', data),
  delete: (id) => apiClient.delete(`/xpunters/v1/competitions/${id}`),
  canDelete: (id) => apiClient.get(`/xpunters/v1/competitions/${id}/can-delete`),
  join: (id, data) => apiClient.post(`/xpunters/v1/competitions/${id}/join`, data),
  checkJoined: (id) => apiClient.get(`/xpunters/v1/competitions/${id}/joined`),
  getPredictions: (id, params) => apiClient.get(`/xpunters/v1/competitions/${id}/predictions`, { params }),
  getStandings: (id) => apiClient.get(`/xpunters/v1/competitions/${id}/standings`),
};

// ==================== PREDICTIONS ====================
export const predictionAPI = {
  create: (data) => apiClient.post('/xpunters/v1/predictions', data),
  submit: (data) => apiClient.post('/xpunters/v1/predictions/submit', data),
  getDetails: (id) => apiClient.get(`/xpunters/v1/predictions/${id}/details`),
  getWithOutcomes: (id) => apiClient.get(`/xpunters/v1/predictions/${id}/with-outcomes`),
  updateSettings: (id, data) => apiClient.post(`/xpunters/v1/predictions/${id}/settings`, data),
  updateResult: (id, data) => apiClient.post(`/xpunters/v1/predictions/${id}/result`, data),
  clear: (id) => apiClient.delete(`/xpunters/v1/predictions/${id}/clear`),
};

// ==================== H2H ====================
export const h2hAPI = {
  getList: (params) => apiClient.get('/xpunters/v1/h2h-games', { params }),
  create: (data) => apiClient.post('/xpunters/v1/h2h-games', data),
  join: (id, data) => apiClient.post(`/xpunters/v1/h2h-games/${id}/join`, data),
  setResult: (id, data) => apiClient.post(`/xpunters/v1/h2h-games/${id}/result`, data),
  canSetResult: (id) => apiClient.get(`/xpunters/v1/h2h-games/${id}/can-set-result`),
  checkEntries: (id) => apiClient.get(`/xpunters/v1/h2h-games/${id}/check-entries`),
  claim: (id) => apiClient.post(`/xpunters/v1/h2h-games/${id}/claim`),
  getClaimStatus: (id) => apiClient.get(`/xpunters/v1/h2h-games/${id}/claim-status`),
};

// ==================== ROLLOVER ====================
export const rolloverAPI = {
  create: (data) => apiClient.post('/xpunters/v1/rollover/create', data),
  addBet: (id, data) => apiClient.post(`/xpunters/v1/rollover/${id}/add-bet`, data),
  getList: (params) => apiClient.get('/xpunters/v1/rollover/games', { params }),
  getSingle: (id) => apiClient.get(`/xpunters/v1/rollover/${id}`),
  join: (id) => apiClient.post(`/xpunters/v1/rollover/${id}/join`),
  checkJoined: (id) => apiClient.get(`/xpunters/v1/rollover/${id}/joined`),
  getBets: (id) => apiClient.get(`/xpunters/v1/rollover/${id}/bets`),
  complete: (id) => apiClient.post(`/xpunters/v1/rollover/${id}/complete`),
  getSubscribers: (id) => apiClient.get(`/xpunters/v1/rollover/${id}/subscribers`),
  getStats: () => apiClient.get('/xpunters/v1/rollover/stats'),
};

// ==================== WALLET ====================
export const walletAPI = {
  getBalance: () => apiClient.get('/xpunters/v1/wallet/balance'),
  fund: (data) => apiClient.post('/xpunters/v1/wallet/fund', data),
  getTransactions: () => apiClient.get('/xpunters/v1/wallet/transactions'),
  initializePayment: (data) => apiClient.post('/xpunters/v1/wallet/initialize-payment', data),
  verifyPayment: (data) => apiClient.post('/xpunters/v1/wallet/verify-payment', data),
  withdraw: (data) => apiClient.post('/xpunters/v1/wallet/withdraw', data),
  getWithdrawalStatus: (id) => apiClient.get(`/xpunters/v1/wallet/withdrawal-status/${id}`),
  getWithdrawalHistory: (params) => apiClient.get('/xpunters/v1/wallet/withdrawal-history', { params }),
};

 
 

// ==================== EXPLORE ====================
export const exploreAPI = {
  getCreators: () => apiClient.get('/xpunters/v1/explore/creators'),
  getSubscriptionStatus: (id) => apiClient.get(`/xpunters/v1/explore/creator/${id}/subscription-status`),
};

// ==================== LEADERBOARD ====================
export const leaderboardAPI = {
  get: (params) => apiClient.get('/xpunters/v1/leaderboard', { params }),
};

// ==================== REFERRALS ====================
export const referralAPI = {
  getStats: () => apiClient.get('/xpunters/v1/referral/stats'),
  getEarningDetails: () => apiClient.get('/xpunters/v1/referral/earning-details'),
  claimBonus: () => apiClient.post('/xpunters/v1/referral/claim-bonus'),
};

// ==================== USER ====================
export const userAPI = {
  getJoinedCompetitions: () => apiClient.get('/xpunters/v1/user/joined-competitions'),
  getPredictions: (params) => apiClient.get('/xpunters/v1/user/predictions', { params }),
  getPredictionStatus: (competitionId) => apiClient.get(`/xpunters/v1/user/prediction-status/${competitionId}`),
  getH2HJoined: () => apiClient.get('/xpunters/v1/user/h2h-joined'),
  getEmailPreferences: () => apiClient.get('/xpunters/v1/user/email-preferences'),
  updateEmailPreferences: (data) => apiClient.post('/xpunters/v1/user/email-preferences', data),
  getEmailPreferenceTypes: () => apiClient.get('/xpunters/v1/email/preference-types'),
  connectX: (data) => apiClient.post('/xpunters/v1/user/connect-x', data),
  disconnectX: () => apiClient.post('/xpunters/v1/user/disconnect-x'),
};

 


// // ==================== CREATOR SUBSCRIPTIONS (Updated) ====================
// export const creatorAPI = {
//   getInfo: () => apiClient.get('/xpunters/v1/creator/subscription/info'),
//   create: (data) => apiClient.post('/xpunters/v1/creator/subscription/create', data),
//   subscribe: (id) => apiClient.post(`/xpunters/v1/creator/${id}/subscribe`),
//   canSubscribe: (id) => apiClient.get(`/xpunters/v1/creator/${id}/can-subscribe`),
//   unsubscribe: (id) => apiClient.post(`/xpunters/v1/creator/${id}/unsubscribe`),
//   getPrivateBets: (id, params) => apiClient.get(`/xpunters/v1/creator/${id}/private-bets`, { params }),
//   getSubscriptions: () => apiClient.get('/xpunters/v1/creator/subscriptions'),
//   // New endpoints
//   getCreatorStatus: (id) => apiClient.get(`/xpunters/v1/creator/${id}/status`),
//   getSubscribers: (id) => apiClient.get(`/xpunters/v1/creator/${id}/subscribers`),
//   updatePricing: (id, data) => apiClient.put(`/xpunters/v1/creator/${id}/pricing`, data),
//   getEarnings: () => apiClient.get('/xpunters/v1/creator/earnings'),
// };


// ==================== CREATOR SUBSCRIPTIONS ====================
export const creatorAPI = {
  getInfo: () => apiClient.get('/xpunters/v1/creator/subscription/info'),
  create: (data) => apiClient.post('/xpunters/v1/creator/subscription/create', data),
  subscribe: (id) => apiClient.post(`/xpunters/v1/creator/${id}/subscribe`),
  canSubscribe: (id) => apiClient.get(`/xpunters/v1/creator/${id}/can-subscribe`),
  unsubscribe: (id) => apiClient.post(`/xpunters/v1/creator/${id}/unsubscribe`),
  getPrivateBets: (id, params) => apiClient.get(`/xpunters/v1/creator/${id}/private-bets`, { params }),
  getSubscriptions: () => apiClient.get('/xpunters/v1/creator/subscriptions'),
  getCreatorStatus: (id) => apiClient.get(`/xpunters/v1/creator/${id}/status`),
  getSubscribers: (id) => apiClient.get(`/xpunters/v1/creator/${id}/subscribers`),
  updatePricing: (id, data) => apiClient.put(`/xpunters/v1/creator/${id}/pricing`, data),
  getEarnings: () => apiClient.get('/xpunters/v1/creator/earnings'),
};

// ==================== SUBSCRIPTION (Updated) ====================
export const subscriptionAPI = {
  getInfo: () => apiClient.get('/xpunters/v1/subscription/info'),
  upgrade: (data) => apiClient.post('/xpunters/v1/subscription/upgrade', data),
  cancel: () => apiClient.post('/xpunters/v1/subscription/cancel'),
  // New endpoints
  getPlans: () => apiClient.get('/xpunters/v1/subscription/plans'),
  checkStatus: () => apiClient.get('/xpunters/v1/subscription/status'),
};







// ==================== ADMIN ====================
export const adminAPI = {
  getStats: () => apiClient.get('/xpunters/v1/admin/stats'),
  getRecentActivity: () => apiClient.get('/xpunters/v1/admin/recent-activity'),
  getPendingValidations: () => apiClient.get('/xpunters/v1/admin/pending-validations'),
  validateBet: (id, data) => apiClient.post(`/xpunters/v1/admin/bet-codes/${id}/validate`, data),
  createMatch: (data) => apiClient.post('/xpunters/v1/admin/matches', data),
  updateMatchResult: (id, data) => apiClient.post(`/xpunters/v1/admin/matches/${id}/result`, data),
};

  
// ==================== FIXTURES ====================
export const fixtureAPI = {
  getList: (params) => apiClient.get('/xpunters/v1/fixtures', { params }),
  getSingle: (id) => apiClient.get(`/xpunters/v1/fixtures/${id}`),
  getUpcoming: (params) => apiClient.get('/xpunters/v1/fixtures/upcoming', { params }),
  getByCompetition: (competitionId, params) => 
    apiClient.get(`/xpunters/v1/fixtures/competition/${competitionId}`, { params }),
  getStandings: (params) => apiClient.get('/xpunters/v1/competition-standings', { params }),
};


// Add these to your endpoints.js

// ==================== CLUBS ====================
export const clubAPI = {
  getList: (params) => apiClient.get('/xpunters/v1/clubs', { params }),
  getSingle: (id) => apiClient.get(`/xpunters/v1/clubs/${id}`),
  create: (data) => apiClient.post('/xpunters/v1/admin/clubs', data),
  update: (id, data) => apiClient.put(`/xpunters/v1/admin/clubs/${id}`, data),
  delete: (id) => apiClient.delete(`/xpunters/v1/admin/clubs/${id}`),
};

// ==================== COMPETITION TYPES (Leagues) ====================
export const competitionTypeAPI = {
  getList: (params) => apiClient.get('/xpunters/v1/competition-types', { params }),
  getSingle: (id) => apiClient.get(`/xpunters/v1/competition-types/${id}`),
  create: (data) => apiClient.post('/xpunters/v1/admin/competition-types', data),
  update: (id, data) => apiClient.put(`/xpunters/v1/admin/competition-types/${id}`, data),
  delete: (id) => apiClient.delete(`/xpunters/v1/admin/competition-types/${id}`),
};

// ==================== MATCHES (Fixtures) ====================
export const matchAPI = {
  getList: (params) => apiClient.get('/xpunters/v1/fixtures', { params }),
  getSingle: (id) => apiClient.get(`/xpunters/v1/fixtures/${id}`),
  getUpcoming: (params) => apiClient.get('/xpunters/v1/fixtures/upcoming', { params }),
  create: (data) => apiClient.post('/xpunters/v1/admin/fixtures', data),
  update: (id, data) => apiClient.put(`/xpunters/v1/admin/fixtures/${id}`, data),
  delete: (id) => apiClient.delete(`/xpunters/v1/admin/fixtures/${id}`),
  updateResult: (id, data) => apiClient.post(`/xpunters/v1/admin/fixtures/${id}/result`, data),
};



// ==================== NOTIFICATIONS ====================
export const notificationAPI = {
  getList: (params) => apiClient.get('/xpunters/v1/notifications', { params }),
  getUnreadCount: () => apiClient.get('/xpunters/v1/notifications/unread-count'),
  markAsRead: (id) => apiClient.post(`/xpunters/v1/notifications/${id}/read`),
  markAllAsRead: () => apiClient.post('/xpunters/v1/notifications/read-all'),
  delete: (id) => apiClient.delete(`/xpunters/v1/notifications/${id}`),
};


// ==================== CRYPTO ====================
export const cryptoAPI = {
  createWallet: (data) => apiClient.post('/xpunters/v1/crypto/wallet/create', data),
  getBalance: () => apiClient.get('/xpunters/v1/crypto/balance'),
  checkDeposits: (data) => apiClient.post('/xpunters/v1/crypto/deposit/check', data),
  processDeposit: (data) => apiClient.post('/xpunters/v1/crypto/deposit/process', data),
  getHistory: () => apiClient.get('/xpunters/v1/crypto/history'),
  // Admin endpoints
  adminGetDeposits: () => apiClient.get('/xpunters/v1/admin/crypto/deposits'),
  adminApproveDeposit: (id) => apiClient.post(`/xpunters/v1/admin/crypto/deposit/${id}/approve`),
  adminCancelDeposit: (id, data) => apiClient.post(`/xpunters/v1/admin/crypto/deposit/${id}/cancel`, data),
  updateWalletSettings: (data) => apiClient.put(`/xpunters/v1/admin/crypto/wallet-settings`, data),
   getWalletSettings: () => apiClient.get(`/xpunters/v1/admin/crypto/wallet-settings`),
};